var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.435 5.60828C23.4502 5.84072 23.4502 6.07401 23.4502 6.30901C23.4502 13.4752 18.0848 21.7387 8.27346 21.7387V21.7336C5.37421 21.7387 2.53683 20.8944 0.0969238 19.3033C0.518124 19.3545 0.941867 19.381 1.36646 19.3819C3.76823 19.3836 6.10136 18.5641 7.99125 17.0558C5.70897 17.0114 3.70721 15.4988 3.00804 13.2898C3.80721 13.447 4.63182 13.4146 5.41574 13.1967C2.92752 12.6848 1.13679 10.463 1.13679 7.88138C1.13679 7.85745 1.13679 7.83523 1.13679 7.81216C1.87834 8.2326 2.70887 8.46589 3.55805 8.49152C1.21391 6.89865 0.491852 3.72913 1.90715 1.25094C4.61572 4.63837 8.61076 6.69783 12.9007 6.91574C12.4711 5.03317 13.0575 3.05917 14.444 1.73462C16.5924 -0.318007 19.9713 -0.212898 21.9909 1.97047C23.185 1.7312 24.3308 1.28512 25.3783 0.653614C24.9799 1.90894 24.1469 2.97542 23.0333 3.65222C24.0909 3.5266 25.1232 3.23777 26.0969 2.79938C25.3808 3.89064 24.4782 4.84004 23.435 5.60828Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.efac6cd5.svg";
export { ForwardRef as ReactComponent };